// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"ea623995","364":"abda25aa","725":"e83807b7"}[chunkId] + ".js";
};